import { SecondaryFilterOptions } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import {
  FORM_CONSTANTS,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { isEmpty } from "lodash";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import { AVAILABILITY_CONSTANTS } from "../../../Availability/constants/AvailabilityConstants";

Vue.use(Vuetify);

@Component({
  name: "EditTemplateName"
})
export default class EditTemplateName extends Vue {
  @Prop() showModal!: boolean;
  @Prop() currentAvailabilityItem!: SecondaryFilterOptions;

  requiredField = FORM_VALIDATORS.REQUIRED_FIELD;

  EDIT_AVAILABILITY = AVAILABILITY_CONSTANTS.TEXTS.EDIT_AVAILABILITY;
  NAME_LABEL = AVAILABILITY_CONSTANTS.LABEL.NAME;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  EDIT_BTN = FORM_CONSTANTS.BUTTON.EDIT;

  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  validateField() {
    return !isEmpty(this.currentAvailabilityItem.name);
  }

  edit() {
    this.$emit(
      AVAILABILITY_CONSTANTS.EVENTS.EDIT_MODAL_ACCEPT,
      this.currentAvailabilityItem
    );
  }

  cancel() {
    this.$emit(AVAILABILITY_CONSTANTS.EVENTS.EDIT_MODAL_CANCEL);
  }
}
